module.exports = function documentTypeToIcon(type) {
    switch(type) {
        case 'PP':
            return 'document-image';
        default:
            return 'document-pdf';
    }
};
